import { jsonObject, jsonString } from "@/transport/decode"
import { expectJson, requestFetch } from "@/transport/http"

const invalidBuild = "The deployed frontend returned invalid build metadata"

/** Reads the build ID of the frontend currently deployed at this origin. */
export async function getDeployedBuildID(signal?: AbortSignal, customFetch: typeof fetch = fetch) {
  const url = `${import.meta.env.BASE_URL}mux-build.json?t=${Date.now().toString(36)}`
  const response = await requestFetch(url, { cache: "no-store", signal }, customFetch)
  return expectJson(response, (value) => jsonString(jsonObject(value, invalidBuild).build, invalidBuild), {
    error: "Could not check for a new Kettle version",
  })
}
